var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 2.21782C14.6834 1.8273 14.6834 1.19413 14.2929 0.803607L14.1964 0.707107C13.8059 0.316583 13.1727 0.316583 12.7822 0.707107L8.20711 5.28218C7.81658 5.6727 7.18342 5.6727 6.79289 5.28218L2.21782 0.707107C1.8273 0.316583 1.19413 0.316582 0.803607 0.707107L0.707107 0.803607C0.316583 1.19413 0.316583 1.8273 0.707107 2.21782L5.28218 6.79289C5.6727 7.18342 5.6727 7.81658 5.28218 8.20711L0.707107 12.7822C0.316583 13.1727 0.316582 13.8059 0.707107 14.1964L0.803607 14.2929C1.19413 14.6834 1.8273 14.6834 2.21782 14.2929L6.79289 9.71782C7.18342 9.3273 7.81658 9.3273 8.20711 9.71782L12.7822 14.2929C13.1727 14.6834 13.8059 14.6834 14.1964 14.2929L14.2929 14.1964C14.6834 13.8059 14.6834 13.1727 14.2929 12.7822L9.71782 8.20711C9.3273 7.81658 9.3273 7.18342 9.71782 6.79289L14.2929 2.21782Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.91632e58.svg";
export { ForwardRef as ReactComponent };